import { detectIE } from '../helpers/browser/browser-detection';

export const browserDetect = () => {
	const body = document.querySelector('body');
	const version = detectIE();

	if (version.isIE === true) {
		body.classList.add('is-ie');
	} else {
		body.classList.remove('is-ie');
	}

	if (version.isIE10 === true) {
		body.classList.add('is-ie-10');
	} else {
		body.classList.remove('is-ie-10');
	}

	if (version.isEdge === true) {
		body.classList.add('is-edge');
	} else {
		body.classList.remove('is-edge');
	}
}

